import { render, staticRenderFns } from "./CashBook.vue?vue&type=template&id=5f24b7ec&"
import script from "./CashBook.vue?vue&type=script&lang=js&"
export * from "./CashBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports